import React from 'react';
import { Link } from "react-router-dom";
import '../styles/subcatcard.css';

const SubCatCard = ({ allSubCategories }) => {
  const subCatArray = Array.from(allSubCategories || []);

  const itemStr = localStorage.getItem('isLogin');
  let item = null;
  try { item = itemStr ? JSON.parse(itemStr) : null; } catch {}
  const now = new Date();

  if (!itemStr || (item && item.expiry < now.getTime())) {
    localStorage.clear();
  }

  const warnLogin = () => {
    // lightweight custom toast (fallback to alert)
    const el = document.createElement('div');
    el.className = 'pq-toast';
    el.innerText = 'You need to Log in or Sign up to get Started!';
    document.body.appendChild(el);
    setTimeout(() => el.classList.add('show'), 10);
    setTimeout(() => {
      el.classList.remove('show');
      setTimeout(() => el.remove(), 300);
    }, 2400);
  };

  return (
    <div className="subcat-card-container">
      <div className="subcat-grid">
        {subCatArray.map((curSubCat, key) => {
          const title = `${curSubCat.SubCatName} Test`;
          const toSlug = curSubCat.SubCatName?.replaceAll(" ", "-") || "";

          return (
            <article key={key} className="subcat-card">
              <header className="subcat-card-header">
                <div className="subcat-card-dot" />
                <h3 className="subcat-card-title">{title}</h3>
              </header>

              <p className="subcat-card-desc">
                A test that uncovers your knowledge about {curSubCat.SubCatName}.
              </p>

              <div className="subcat-actions">
                {itemStr ? (
                  <Link
                    to={{ pathname: `/online-practice-test/${toSlug}` }}
                    state={{ type: "subcategory-test" }}
                    className="subcat-btn"
                  >
                    <span>Take Test Now</span>
                    <svg className="subcat-btn-ico" viewBox="0 0 24 24" width="16" height="16" aria-hidden>
                      <path d="M5 12h12m0 0l-5-5m5 5l-5 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </Link>
                ) : (
                  <button type="button" onClick={warnLogin} className="subcat-btn">
                    <span>Take Quiz</span>
                    <svg className="subcat-btn-ico" viewBox="0 0 24 24" width="16" height="16" aria-hidden>
                      <path d="M5 12h12m0 0l-5-5m5 5l-5 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                )}
              </div>

              <span className="subcat-card-accent" aria-hidden="true" />
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default SubCatCard;
